import { useState, useEffect } from 'react'

export const useResendTimer = (initialTime = 60) => {
  const [timer, setTimer] = useState(0)

  useEffect(() => {
    if (timer <= 0) return
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1)
    }, 1000)
    return () => clearInterval(interval)
  }, [timer])

  const startTimer = () => setTimer(initialTime)
  const stopTimer = () => setTimer(0)

  return { timer, startTimer, stopTimer }
}
